import "./src/js/blockEdit";
import "./src/js/registerBlockType";
import "./src/scss/style.scss";

window.lodash = _.noConflict();